import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/dianying', label: '电影' },
    { to: '/category/dianshiju', label: '电视剧' },
    { to: '/category/dongman', label: '动漫' },
    { to: '/category/zongyi', label: '综艺' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="px-4 md:px-6 py-3 flex items-center justify-between max-w-[1400px] mx-auto">
        <Link
          to="/"
          className="flex items-center gap-2 text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
        >
          <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
            <i className="ri-play-fill text-white text-lg"></i>
          </div>
          <span className="text-xl font-bold font-heading text-foreground-900 whitespace-nowrap">
            番茄视频
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                location.pathname === link.to
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <button
            className="w-9 h-9 rounded-lg flex items-center justify-center text-foreground-600 hover:text-primary-600 hover:bg-background-100 transition-colors cursor-pointer"
            aria-label="搜索"
          >
            <i className="ri-search-line text-lg"></i>
          </button>
        </div>

        <button
          className="md:hidden w-9 h-9 rounded-lg flex items-center justify-center text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
          onClick={() => setIsMobileOpen(!isMobileOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {isMobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-3">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                  location.pathname === link.to
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}